<template>
  <div id="popupSingle">
    <a-modal :title="$t('pubGicSet.GenerateLocation')" v-model="visible" width="70%">
      <template slot="footer">
        <a-button type="primary" sizez="small" @click="sbmitWasLocation">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <div>
        <a-form :form="form">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" :label="$t('userlang.Warehouse')">
                <a-select
                  style="width: 100%"
                  :placeholder="$t('publicLang.PleaseSelect')"
                  size="small"
                  v-decorator="[
                    'warehouseCode',
                    {
                      initialValue: warehouseCodeDefVal,
                      rules: [{ required: true, message: $t('publicLang.Required') }]
                    }
                  ]">
                  <a-select-option
                    v-for="item in wasDropList"
                    :value="item.code"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" :label="$t('pubGicSet.RowName')">
                <a-input
                  size="small"
                  :placeholder="$t('pubGicSet.RowName')"
                  style="width:100%"
                  v-decorator="[
                    'rowName',
                    { rules: [{ required: true, message: $t('publicLang.Required') }] }
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" :label="$t('pubGicSet.ColumnInRow')">
                <a-input-number
                  size="small"
                  :placeholder="$t('pubGicSet.ColumnInRow')"
                  style="width:100%"
                  v-decorator="[
                    'columnInRow',
                    { rules: [{ required: true, message: $t('publicLang.Required') }] }
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" :label="$t('pubGicSet.LevelInRow')">
                <a-input-number
                  size="small"
                  :placeholder="$t('pubGicSet.LevelInRow')"
                  style="width:100%"
                  v-decorator="[
                    'levelInRow',
                    { rules: [{ required: true, message: $t('publicLang.Required') }] }
                  ]"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout" :label="$t('pubGicSet.BinsinLocation')">
                <a-input-number
                  size="small"
                  :placeholder="$t('pubGicSet.BinsinLocation')"
                  style="width:100%"
                  v-decorator="[
                    'binsInLocation',
                    { rules: [{ required: true, message: $t('publicLang.Required') }] }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
export default {
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      wasDropList: [],
      warehouseCodeDefVal: undefined,// warehouseCode 默认值
    };
  },
  methods: {
    close() {
      this.visible = false;
    },
    open() {
      ajax.get(api.WAREHOUSEDROP).then(res => {
          this.wasDropList = res.data;
          if(this.wasDropList.length == 1){
              this.warehouseCodeDefVal = this.wasDropList[0].code
          }
      });
      this.visible = true;
    },
    sbmitWasLocation() {
      this.form.validateFields((err, val) => {
        if (!err) {
          ajax.post(api.SUBMITGENERATIONLOCATION, val).then(res => {
            if (res.code == 200) {
              this.visible = false;
              this.form.resetFields();
              this.$emit("generatelocation", "init");
            } else {
              this.$customMessage.error(res.msg);
            }
          });
        }
      });
    }
  }
};
</script>
